import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { usePageTitle } from "@/hooks/usePageTitle";
import { withBranding } from "@/utils/helper";
import { cn } from "@/utils/cn";
import { Pagination } from "@/components/table/Pagination";
import { TeamMembersList } from "./team-members";
import { usePerformanceTeamMemberParams } from "../_components/performance.params";
const ManagePerformance = () => {
  const { t } = useTranslation(["nav", "company", "common"]);
  const TABS = [
    { label: t("company:performance.team_members_tab"), to: ".", end: true },
    {
      label: t("company:performance.performance_configuration_tab"),
      to: "performance-configuration",
      end: false,
    },
  ] as const;
  usePageTitle(withBranding(t("nav:tabs.performance")));
  return (
    <div className="flex flex-col flex-1 min-h-0 bg-white border rounded-sm">
      <div className="sticky -top-2.5 md:-top-4 z-20 bg-white shrink-0 border-b border-border">
        <div className="overflow-x-auto scrollbar-thin flex items-stretch">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  "relative flex items-center shrink-0 px-2 py-4 md:px-4 md:py-5",
                  "text-[10px] md:text-xs font-semibold uppercase transition-colors duration-200",
                  isActive
                    ? "text-primary bg-primary/10 border-b-[3px] border-primary"
                    : "text-primary-strong hover:bg-primary/5 hover:text-primary",
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default ManagePerformance;

export const TeamMembersPage = () => {
  // Search, filters and page all live in the URL — see useTableParams.
  const tableParams = usePerformanceTeamMemberParams();
  const [totalPages, setTotalPages] = useState(0);

  const handleTotalPages = useCallback((n: number) => {
    setTotalPages((prev) => (prev === n ? prev : n));
  }, []);

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <TeamMembersList params={tableParams} onTotalPages={handleTotalPages} />
      {totalPages > 1 && (
        <div className="sticky -bottom-2.5 md:-bottom-4 z-20 shrink-0 border-t bg-white py-3 px-5 flex items-center justify-center">
          <Pagination
            currentPage={tableParams.page}
            totalPages={totalPages}
            onPageChange={tableParams.setPage}
          />
        </div>
      )}
    </div>
  );
};
